import { CommonActions } from '@react-navigation/native';

const enrichClaimedCoupon = (coupon, kawanActivation = null) => {
  const claimId = coupon.claim_id || coupon.claimId;
  const tipe = coupon.tipe_kupon || coupon.type;
  return {
    ...coupon,
    claim_id: claimId,
    claimId,
    is_claimed: true,
    kawan_activation: kawanActivation || coupon.kawan_activation || null,
    paygift: !!(coupon.paygift || coupon.isPaygift || tipe === 'paygift'),
    isPaygift: !!(coupon.isPaygift || coupon.paygift || tipe === 'paygift'),
    indobest: !!(coupon.indobest || coupon.isIndobest || tipe === 'indobest'),
    isIndobest: !!(coupon.isIndobest || coupon.indobest || tipe === 'indobest'),
  };
};

const couponDetailsScreenName = (coupon) => {
  const tipe = coupon?.tipe_kupon || coupon?.type;
  if (coupon?.isIndobest || tipe === 'indobest') return 'IndobestCouponDetails';
  if (coupon?.isPaygift || tipe === 'paygift') return 'PaygiftCouponDetails';
  return 'CouponDetails';
};

/**
 * Navigate to the correct coupon details screen after QR claim.
 */
export function navigateToClaimedCouponDetails(navigation, coupon, kawanActivation = null) {
  if (!coupon || !navigation) return false;
  const enriched = enrichClaimedCoupon(coupon, kawanActivation);
  navigation.navigate(couponDetailsScreenName(enriched), { coupon: enriched });
  return true;
}

/**
 * Open coupon detail with Coupons list underneath, so Back returns to daftar kupon.
 * Used by ZID "lihat voucher" and Riwayat Tukar Poin.
 */
export function openCouponDetailsOverCouponsList(navigation, coupon, kawanActivation = null) {
  if (!coupon || !navigation) return false;
  const enriched = enrichClaimedCoupon(coupon, kawanActivation);
  navigation.dispatch(
    CommonActions.reset({
      index: 1,
      routes: [
        { name: 'MainTabs', params: { screen: 'Coupons' } },
        { name: couponDetailsScreenName(enriched), params: { coupon: enriched } },
      ],
    }),
  );
  return true;
}

export function goToCouponsList(navigation) {
  if (!navigation) return;
  navigation.navigate('MainTabs', { screen: 'Coupons' });
}

export function shouldNavigateToCouponDetails(scanResult) {
  if (!scanResult?.coupon) return false;
  const t = scanResult?.type;
  return t === 'coupon' || t === 'all' || t === 'coupon_stamp' || t === 'coupon_points';
}

export function shouldDirectToCouponAfterKawanClaim(scanResult) {
  if (!shouldNavigateToCouponDetails(scanResult)) return false;

  const activation = scanResult?.kawanActivation;
  if (!activation) return false;

  return activation.store_point_enabled === true || activation.status === 'claimed';
}

export function openCouponDetail(navigation, coupon, kawanActivation = null) {
  if (!coupon || !navigation) return false;
  const enriched = enrichClaimedCoupon(coupon, kawanActivation);

  navigation.replace(couponDetailsScreenName(enriched), { coupon: enriched });
  return true;
}